export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: 'createdAt',
    label: 'label.no',
  },
  {
    key: 'id',
    sortable: false,
    label: 'field.topic',
    class: 'break-spaces',
  },
  {
    key: 'pendingCount',
    sortable: false,
    label: 'status.pending',
  },
  {
    key: 'approvedCount',
    sortable: false,
    label: 'status.approved',
  },
  {
    key: 'rejectedCount',
    sortable: false,
    label: 'status.ignored',
  },
  {
    key: 'count',
    sortable: false,
    label: 'field.count',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
]
